export enum RankingSortType {
  RANKING_SORT_TOTAL = "RANKING_SORT_TOTAL",
  RANKING_SORT_AVERAGE = "RANKING_SORT_AVERAGE",
}
